function createStorageAccessor(storage: Storage) {
	return function <ValueType>(
		storageKey: string,
		valueChecker: (v: unknown) => v is ValueType,
		defaultFunc: () => ValueType,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
		updateParsed: (v: any) => any = (v) => v,
	) {
		// eslint-disable-next-line @typescript-eslint/no-unsafe-return
		return createStoredValue(storage)<ValueType, ValueType>(storageKey, valueChecker, defaultFunc, JSON.stringify, (x) => updateParsed(JSON.parse(x))).get();
	};
}

export const initialiseStoreValue = createStorageAccessor(sessionStorage);
export const initialiseLocalStoreValue = createStorageAccessor(localStorage);

interface StoredValue<ValueType, DefaultValueType> {
	get(): ValueType | DefaultValueType;
	set(value: ValueType): void;
	remove(): void;
}

function createStoredValue(storage: Storage) {
	return <ValueType, DefaultValueType>(key: string,
		valueChecker: (v: unknown) => v is ValueType,
		defaultFunc: () => DefaultValueType,
		stringifyValue: (value: ValueType) => string = JSON.stringify,
		parseValue: (value: string) => ValueType = JSON.parse) => ({
			get() {
				const storedInput = storage.getItem(key);
				if (storedInput) {
					try {
						const userInput = parseValue(storedInput);
						if (valueChecker(userInput)) {
							return userInput;
						}
					} catch (e) {
						storage.removeItem(key);
					}
				}
				return defaultFunc();
			},
			set(value) {
				storage.setItem(key, stringifyValue(value));
			},
			remove() {
				storage.removeItem(key);
			},
		}) as StoredValue<ValueType, DefaultValueType>;
}

export const sessionStorageValue = createStoredValue(sessionStorage);
export const localStorageValue = createStoredValue(localStorage);
